// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FqweyAPf{align-items:center;display:flex;gap:.5em;margin:0}`, "",{"version":3,"sources":["webpack://./src/page-components/shared/notification-message.module.scss"],"names":[],"mappings":"AAAA,UACE,kBAAA,CACA,YAAA,CACA,QAAA,CACA,QAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FqweyAPf`
};
export default ___CSS_LOADER_EXPORT___;
